export const HOME = '/';
export const CONTACT = '/contact';
export const TERMS_OF_SERVICE = '/terms-of-service';
export const PRIVACY_POLICY = '/privacy-policy';
export const CHECKOUT = '/checkout';
export const ACCOUNT_SETTINGS = '/my-profile';
export const Booking_History = '/booking-history';
export const ADDRESSES = '/addresses';
export const No_family_members = '/no-family-members';
export const No_addresses = '/no-addresses';
export const No_booking_history = '/no-booking-history';
export const FAMILY_MEMBER = '/family-members';
export const Test_Detail = '/test-detail';
export const Lab_Detail = '/lab-detail';
export const HEADERCANTERLOGO = '/Headercanterlogo';
export const SLIDEMENU = '/Slidemenu';
export const HEADERMAIN = '/Headermain';
export const HEADER = '/Header';
export const FOOTER = '/Footer';
